
import { db } from '@/integrations/neon/db';

/**
 * Increments magazine_generations by 1 for the given user.
 * If no statistics row exists, creates one.
 * @param userId string (uuid)
 */
export const incrementMagazineGenerations = async (userId: string) => {
  if (!userId) return;

  // Find existing stats row
  const { data: stats, error } = await db
    .from("statistics")
    .select("id, magazine_generations")
    .eq("user_id", userId)
    .maybeSingle();

  if (error) {
    console.error("Error fetching statistics row:", error);
    return;
  }

  if (stats && stats.id) {
    // Update: increment the counter
    const incValue =
      typeof stats.magazine_generations === "number"
        ? stats.magazine_generations + 1
        : 1;
    const { error: updateError } = await db
      .from("statistics")
      .update({
        magazine_generations: incValue,
        updated_at: new Date().toISOString(),
      })
      .eq("id", stats.id);

    if (updateError) {
      console.error("Error updating magazine_generations:", updateError);
    }
  } else {
    // Insert: no row exists, create it
    const { error: insertError } = await db
      .from("statistics")
      .insert([
        {
          user_id: userId,
          magazine_generations: 1,
          created_at: new Date().toISOString(),
          updated_at: new Date().toISOString(),
        },
      ]);
    if (insertError) {
      console.error("Error inserting magazine_generations row:", insertError);
    }
  }
};
